import { render } from "./WCCartDrawerItems.vue?vue&type=template&id=49004ca7&scoped=true"
import script from "./WCCartDrawerItems.vue?vue&type=script&lang=js"
export * from "./WCCartDrawerItems.vue?vue&type=script&lang=js"

import "./WCCartDrawerItems.vue?vue&type=style&index=0&id=49004ca7&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49004ca7"]])

export default __exports__